import { useQuery } from "@tanstack/react-query";
// import { useSelector } from "../../../../../store/store";

import { EprCodeProcessService as EPRCodeApis } from "../../../../../services/eprcode-process/eprcode-process.service";
import { ITableParams } from "../../../../../modules/table";
import {
  getStatusBaseOnApprover,
  getStepBaseOnApprover,
} from "../../delete-user-account/utils";
import { transformRequestStatus } from "../../../utils";
import { useUser } from "../../../../../hook";

export const useEPRCodeRequests = () => {
  const {email} = useUser();
  const emailThienNV = 'thiennv@viags.vn';

  const { data = [], ...restResponse } = useQuery<Array<any>>({
    queryKey: ["epr-code-requests"],
    queryFn: () => EPRCodeApis.getEPRCodeRequests(emailThienNV, {} as ITableParams),
  });

  
  const { data: data2 = [] } = useQuery<Array<any>>({
    queryKey: ["epr-code-requests2"],
    queryFn: () => EPRCodeApis.getEPRCodeRequests(email, {} as ITableParams),
  });

  const eprCodeMyRequests = data.filter(
    (el) => el.createdBy.user.email.toLowerCase() === email.toLowerCase()
  );

  const mappedEPRCodeRequests = data.map((record) => {
    const status = getStatusBaseOnApprover(record.fields, emailThienNV);
    const step = getStepBaseOnApprover(record.fields, emailThienNV);
    return {
      ...record.fields,
      id: record.id,
      createdByEmail: record.createdBy.user.email,
      createdByName: record.createdBy.user.displayName,
      createdDateTime: record.createdDateTime,
      eRequestStatus: transformRequestStatus(status, { step }),
    };
  }).sort((a,b) => b.id - a.id);

  const mappedEPRCodeRequests2 = data2.map((record) => {
    const status = getStatusBaseOnApprover(record.fields, emailThienNV);
    const step = getStepBaseOnApprover(record.fields, emailThienNV);
    return {
      ...record.fields,
      id: record.id,
      createdByEmail: record.createdBy.user.email,
      createdByName: record.createdBy.user.displayName,
      createdDateTime: record.createdDateTime,
      eRequestStatus: transformRequestStatus(status, { step }),
    };
  }).sort((a,b) => b.id - a.id);

  const mappedEPRCodeMyRequests = mappedEPRCodeRequests.filter(
    (record) => record.createdByEmail.toLowerCase() === email.toLowerCase()
  ).sort((a,b) => b.id - a.id);

  const guideLink = "https://drive.google.com/file/d/1SA1H-et01x5ZevRqVfugs1ioc76Doq2J/view"

  return {
    ...restResponse,
    eprCodeRequests: data,
    eprCodeMyRequests,
    mappedEPRCodeRequests,
    mappedEPRCodeMyRequests,
    mappedEPRCodeRequests2,
    guideLink
  };
};
